import { createRequest } from "helpers/tools";

/**
 * @typedef {Object} ReconnectLeadSourcePayload
 * @property {string} platform facebook | tiktok
 * @property {string} access_token
 */

/**
 *
 * @param {number} id
 * @param {ReconnectLeadSourcePayload} payload
 * @returns {void}
 */
export const reconnectLeadSource = async (id, payload) => {
    return await createRequest({
        suffix: `lead/connection/${id}/sources/reconnect`,
        method: "post",
        payload,
        handleError: false,
    });
};

export const reconnectLeadDestination = async (destination_id, payload) => {
    return await createRequest({
        suffix: `lead/destinations/${destination_id}/reconnect`,
        method: "post",
        payload,
        handleError: false,
    });
};
